export const KRPANO_XML_VERSION = 'v=2026.09.30.02';

export const KRPANO_LOG_QUERY_PARAM = 'log';

const KRPANO_LOG_STORAGE_KEY = 'panoee_krpano_log';

type KrpanoLogApi = {
  set: (key: string, value: boolean) => void;
  call: (action: string) => void;
  events?: {
    onloaderror?: (() => void) | null;
    onxmlerror?: (() => void) | null;
  };
};

const readKrpanoLogStorage = () => {
  try {
    return window.sessionStorage.getItem(KRPANO_LOG_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const writeKrpanoLogStorage = (enabled: boolean) => {
  try {
    if (enabled) window.sessionStorage.setItem(KRPANO_LOG_STORAGE_KEY, '1');
    else window.sessionStorage.removeItem(KRPANO_LOG_STORAGE_KEY);
  } catch {
    return;
  }
};

export const isKrpanoPublicLogEnabled = () => {
  if (typeof window === 'undefined') return false;
  const value = new URLSearchParams(window.location.search).get(
    KRPANO_LOG_QUERY_PARAM,
  );
  if (value === '0' || value === 'false') {
    writeKrpanoLogStorage(false);
    return false;
  }
  if (value === '1' || value === 'true') {
    writeKrpanoLogStorage(true);
    return true;
  }
  return readKrpanoLogStorage();
};

export const appendKrpanoLogQuery = (url: string) => {
  if (!isKrpanoPublicLogEnabled()) return url;
  const hashIndex = url.indexOf('#');
  const hash = hashIndex >= 0 ? url.slice(hashIndex) : '';
  const path = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
  const [pathname, search = ''] = path.split('?');
  const params = new URLSearchParams(search);
  params.set(KRPANO_LOG_QUERY_PARAM, '1');
  return `${pathname}?${params.toString()}${hash}`;
};

export const applyKrpanoPublicLogVisibility = (krpano: KrpanoLogApi) => {
  const enabled = isKrpanoPublicLogEnabled();
  krpano.set('showerrors', enabled);
  krpano.set('logkey', enabled);
  krpano.set('debugmode', enabled);
  krpano.set('debugkeys', enabled);
  if (enabled) {
    if (krpano.events) {
      krpano.events.onloaderror = null;
      krpano.events.onxmlerror = null;
    }
    krpano.call('showlog()');
    return;
  }
  krpano.call('closelog()');
  if (krpano.events) {
    krpano.events.onloaderror = () => krpano.call('closelog()');
    krpano.events.onxmlerror = () => krpano.call('closelog()');
  }
};
